import { Modal } from '@numa-group/ui.modal';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { GuestAmountInput } from './components/guest-amount-input/guest-amount-input';
import { useBottomNavigation } from '../../../../bottom-navigation.context';
import { SearchSchema } from '../../search.schema';

type SearchGuestsProps = {
  isSubmitting: boolean;
};
export const SearchGuests = ({ isSubmitting }: SearchGuestsProps) => {
  const form = useFormContext<SearchSchema>();
  const {
    content: { confirmCta, adults, adultsDescription, children, childrenDescription, infants, infantsDescription },
  } = useBottomNavigation();
  const { formatMessage } = useIntl();

  return (
    <>
      <Modal.Body>
        <Modal.Content>
          <GuestAmountInput
            control={form.control}
            name="guests.adults"
            minValue={1}
            label={formatMessage(
              {
                id: 'adults',
                defaultMessage: adults,
              },
              {
                count: 2,
              },
            )}
            subLabel={adultsDescription}
          />
          <GuestAmountInput
            control={form.control}
            name="guests.children"
            minValue={0}
            label={formatMessage(
              {
                id: 'children',
                defaultMessage: children,
              },
              {
                count: 2,
              },
            )}
            subLabel={childrenDescription}
          />
          <GuestAmountInput
            control={form.control}
            minValue={0}
            name="guests.infants"
            label={formatMessage(
              {
                id: 'infants',
                defaultMessage: infants,
              },
              {
                count: 2,
              },
            )}
            subLabel={infantsDescription}
          />
        </Modal.Content>
      </Modal.Body>

      <Modal.Footer>
        <Modal.FooterAction isLoading={isSubmitting}>{confirmCta}</Modal.FooterAction>
      </Modal.Footer>
    </>
  );
};
